import * as z from 'zod';

/**
 * Marks an exportable field as PII (personally identifiable information) so downstream surfaces —
 * notably the data-lake schema browser — can flag it for engineers writing queries against the
 * lake. Merges with any existing `.describe()`/`.meta()` rather than replacing it, so annotating a
 * field that already has a description keeps both.
 *
 * This is an advisory annotation for humans exploring the schema, not an access control. Mark a
 * field only when it is clearly PII; under-marking gives a false sense of safety, so coverage
 * should be reviewed against the data classification policy rather than guessed at.
 */
export const pii = <T extends z.ZodType>(schema: T): T => schema.meta({ ...(schema.meta() ?? {}), pii: true }) as T;
